import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {AzPageHeader} from '../../components/AzPageHeader'
import { ContactListWrapper } from './ContactComponent'
import { useIntl } from 'react-intl'

const ContactPage = () => {
  const intl = useIntl()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Contact'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'CONTACT_PAGE.TITLE' })} />
              <ContactListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/Contact-management/Contact' />} />
    </Routes>
  )
}

export default ContactPage
